type ChatCryptoDebugDetails = Record<string, unknown>;

declare global {
  interface Window {
    __chatCryptoDebug?: boolean;
  }
}

function isEnabledFromUrl(): boolean {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    return (searchParams.get('chat_crypto_debug') || '').trim() === '1';
  } catch {
    return false;
  }
}

export function isChatCryptoDebugEnabled(): boolean {
  try {
    return import.meta.env.DEV
      || localStorage.getItem('chatCryptoDebug') === '1'
      || window.__chatCryptoDebug === true
      || isEnabledFromUrl();
  } catch {
    return import.meta.env.DEV;
  }
}

export function toCommitmentHint(value: string | null | undefined): string | null {
  const clean = typeof value === 'string' ? value.trim() : '';
  if (!clean) return null;
  return clean.slice(0, 12);
}

export function logChatCrypto(scope: string, stage: string, details: ChatCryptoDebugDetails = {}): void {
  if (!isChatCryptoDebugEnabled()) return;
  console.log(`[ChatCrypto:${scope}]`, {
    stage,
    ...details
  });
}
